import Vue from 'vue';
import { fetchTag, createPacket, updatePacket, fetchPacketDetail } from '@/api/courseOn';
import COS from 'cos-js-sdk-v5'; // 上传
import initCos from '@/utils/upload/tencentCos';

export default {
  name: 'addCourse',
  data() {
    return {
      loading: false,
      loadingTxt: '数据加载中...',
      stageLoading: false,
      subjectLoading: false,
      coverImgs: [],
      form: {
        cover: null,
        sale_status: 2,
        detail: '',
      },
      rules: {
        cover: [
          { required: true, message: '请上传封面图片', trigger: 'change' },
        ],
        name: [
          {
            required: true,
            message: '请输入课程名称',
          },
        ],
        introduction: [
          {
            required: true,
            message: '请输入课程简介',
          },
        ],
        detail: [
          {
            required: true,
            message: '请输入课程详细说明',
          },
        ],
        stage_tag_id: [
          {
            required: true,
            message: '请选择年级',
            trigger: 'change',
          },
        ],
        subject_tag_id: [
          {
            required: true,
            message: '请选择科目',
            trigger: 'change',
          },
        ],
      },
      gradeOptions: [],
      subjectOptions: [],
      upType: ['jpg', 'jpeg', 'png'],
      formDialogVisible: false,
      editMenus: [
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'fontName', // 字体
        'italic', // 斜体
        'underline', // 下划线
        'strikeThrough', // 删除线
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        // 'link', // 插入链接
        'list', // 列表
        'justify', // 对齐方式
        'quote', // 引用
        'undo', // 撤销
        'redo', // 重复
      ],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.loading = true;
      const stage = await fetchTag('stage');
      const subject = await fetchTag('subject');
      const stageArr = [];
      const subjectArr = [];
      stage.items.forEach((item) => {
        stageArr.push({ value: item.id, label: item.name });
      });
      subject.items.forEach((item) => {
        subjectArr.push({ value: item.id, label: item.name });
      });
      this.gradeOptions = stageArr;
      this.subjectOptions = subjectArr;
      if (this.$route.query.packetId) {
        this.getDetail(this.$route.query.packetId);
      } else {
        this.loading = false;
      }
    },
    // 获取课程详情
    getDetail(id) {
      fetchPacketDetail(id, this.$store.state.choicesSchool.id).then((res) => {
        console.log('详情', res);
        this.loading = false;
        this.coverImgs.push({
          src: res.data.cover,
        });
        this.formDialogVisible = true;
        this.form = {
          id: res.data.id,
          cover: res.data.cover,
          name: res.data.name,
          introduction: res.data.introduction,
          detail: res.data.detail,
          stage_tag_id: res.data.stage_tag_id,
          subject_tag_id: res.data.subject_tag_id,
          sale_status: res.data.sale_status,
        };
      });
    },
    // 上传图片 - 格式限制 所有文件(*.*)
    upImg(file, fileList) {
      let isImg = true;
      fileList.forEach((val, index) => {
        if (!this.upType.includes(val.name.match(/\.\w+$/)[0].replace('.', '').toLowerCase())) {
          fileList.splice(index, 1);
          this.$message.warning('上传含非图片的文件');
          isImg = false;
        }
      });
      if (isImg) {
        this.coverImgs = [];
        this.coverImgs.push(file);
      }
    },

    // 上传 图片和文档
    upFile() {
      const files = this.coverImgs;
      files.map((val, index) => {
        if (!val.loading) {
          val.loading = true;
          initCos(val.raw, this.$store.state.choicesSchool.id, (res) => {
            const cos = res.cos;
            const _key = `${res.resource_dir}${res.md5}.${res.type}`;
            Vue.set(files[index], 'progress', '0%');
            cos.putObject({
              Bucket: res.Bucket, /* 必须 */
              Region: res.Region, /* 存储桶所在地域，必须字段 */
              Key: _key, /* 必须 */
              StorageClass: 'STANDARD',
              Body: val.raw, // 上传文件对象
              onProgress(pre) {
                for (let i = 0; i < files.length; i++) {
                  if (files[i].uid === val.uid) {
                    Vue.set(files[i], 'progress', `${pre.percent.toFixed(2) * 1e3 / 10}%`);
                    break;
                  }
                }
              },
            }, (err, data) => {
              if (err && err.statusCode === 403) {
                this.$message.error('token失效, 请刷新页面！');
              } else {
                for (let i = 0; i < files.length; i++) {
                  if (files[i].uid === val.uid) {
                    Vue.set(files[i], 'src', `https://${data.Location}`);
                    break;
                  }
                }
                this.form.cover = files[0].src;
              }
            });
          });
        }
      });
    },
    // 删除图片
    delCoverImage(index) {
      this.coverImgs.splice(index, 1);
      this.form.cover = null;
    },
    // 新增
    handlerCreate() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.loadingTxt = '数据提交中...';
          const formData = new FormData();
          formData.append('cover', this.form.cover);
          formData.append('name', this.form.name);
          formData.append('introduction', this.form.introduction);
          formData.append('detail', this.form.detail);
          formData.append('stage_tag_id', this.form.stage_tag_id);
          formData.append('subject_tag_id', this.form.subject_tag_id);
          formData.append('sale_status', this.form.sale_status);
          createPacket(this.$store.state.choicesSchool.id, this.form).then((res) => {
            this.loading = false;
            if (res.status_code === 200) {
              this.$message.success('新增课件成功！');
              this.$router.replace('/putOn');
            } else {
              this.$message.error('新增课件失败！');
            }
          }).catch((err) => {
            console.log(err);
            this.loading = false;
            this.$message.error('提交数据失败！');
          });
        }
      });
    },
    // 更新
    handlerUpdate() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.loadingTxt = '数据提交中...';
          const formData = new FormData();
          formData.append('id', this.form.id);
          formData.append('cover', this.form.cover);
          formData.append('name', this.form.name);
          formData.append('introduction', this.form.introduction);
          formData.append('detail', this.form.detail);
          formData.append('stage_tag_id', this.form.stage_tag_id);
          formData.append('subject_tag_id', this.form.subject_tag_id);
          formData.append('sale_status', this.form.sale_status);
          updatePacket(this.$store.state.choicesSchool.id, this.form).then((res) => {
            this.loading = false;
            if (res.status_code === 200) {
              this.$message.success('更新课件成功！');
              this.$router.replace('/putOn');
            } else {
              this.$message.error('更新课件失败！');
            }
          }).catch((err) => {
            console.log(err);
            this.loading = false;
            this.$message.error('提交数据失败！');
          });
        }
      });
    },
    handlerClose() {
      // this.$router.go(-1)
      this.$router.replace('/putOn');
    },
    // 商品详情 - 富文本框
    changeFn(data) {
      if (data === '<p><br></p>') {
        this.form.detail = '';
      } else {
        this.form.detail = data;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/CourseOn/addCourse/addCourse.js